module.exports = __webpack_public_path__ + "media/childcare.d60916c5.svg";